import(/* webpackMode: "eager" */ "/opt/fructidor/fructidor-ui/releases/20250410113957/node_modules/@mui/material/Skeleton/index.js");
